import { MappingSchema } from '../mapping';

export class ActualityEmployeeShift {
  // actualityId: string;
  shiftId: string;
  employeeId: string;
  shiftStart: Date;
  shiftEnd: Date;
}

export const ACTUALITY_EMPLOYEE_SHIFT_MAPPING_SCHEMA: MappingSchema<ActualityEmployeeShift> =
  {
    title: `Actuality Employee Shift`,
    description: ``,
    // partitionBy: [{ key: 'actualityId' }],
    fields: [
      // {
      //   name: 'actualityId',
      //   type: 'string',
      //   title: 'Actuality Id',
      //   description: '',
      // },
      {
        name: 'shiftId',
        type: 'string',
        title: 'Shift Id',
        description: '',
      },
      {
        name: 'employeeId',
        type: 'string',
        title: 'User Id',
        description: '',
      },
      {
        name: 'shiftStart',
        type: 'localDateTime',
        title: 'Shift Start',
        description: '',
      },
      {
        name: 'shiftEnd',
        type: 'localDateTime',
        title: 'Shift End',
        description: '',
      },
    ],
    includeRawData: true,
    primaryKey: ['shiftId'],
  };
